import { render, staticRenderFns } from "./TablePaginate.vue?vue&type=template&id=1d3114b0&scoped=true"
import script from "./TablePaginate.vue?vue&type=script&lang=js"
export * from "./TablePaginate.vue?vue&type=script&lang=js"
import style0 from "./TablePaginate.vue?vue&type=style&index=0&id=1d3114b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3114b0",
  null
  
)

export default component.exports